import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SiteDataCleanerService, VERSION_KEY } from '../services/site-data-cleaner.service';
import { VersionCheckService } from '../services/version-check.service';

interface VersionInfo {
  version: string;
  buildHash: string;
  buildDate: string;
}

/**
 * APP_INITIALIZER que verifica la versión al arrancar la app.
 *
 * Si detecta un buildHash diferente al almacenado, NO limpia ni recarga
 * automáticamente. Solo muestra el banner para que el usuario decida.
 *
 * La limpieza y el reload ocurren únicamente cuando el usuario hace clic
 * en "Actualizar ahora".
 */
export function versionCheckInitializerFactory(
  http: HttpClient,
  _cleaner: SiteDataCleanerService,
  versionCheckService: VersionCheckService
): () => Promise<void> {
  return async (): Promise<void> => {
    try {
      const versionInfo = await firstValueFrom(
        http.get<VersionInfo>(`/assets/version.json?t=${Date.now()}`)
      );

      if (!versionInfo?.buildHash) {
        return;
      }

      const storedHash = localStorage.getItem(VERSION_KEY);

      if (!storedHash) {
        // Primera vez que se ejecuta la app → guardar hash sin mostrar toast
        localStorage.setItem(VERSION_KEY, versionInfo.buildHash);
      } else if (storedHash !== versionInfo.buildHash) {
        // Nueva versión detectada → mostrar banner, el usuario decide.
        // NO se actualiza localStorage aquí. Solo se actualiza cuando el
        // usuario hace clic en "Actualizar ahora" (dentro de applyUpdate).
        versionCheckService.notifyNewVersion(versionInfo.buildHash);
      }
    } catch {
      // Si falla la verificación (sin red, 404, etc.) la app arranca normalmente
      console.warn('[VersionInit] No se pudo verificar la versión al iniciar.');
    }
  };
}
